export default __webpack_public_path__ + "static/media/pack1.fc55c721.png";